<template>
  <div data-v-e5781868="" class="app-wrapper">
      <Header />
      <router-view />
      <Foot />
    <AllLogin />
    <div data-v-3e52ce59="" class="loading" v-if="loading"><div data-v-3e52ce59="" class="loader"><span data-v-3e52ce59="" class="load-img"></span></div></div>
  </div>
</template>

<script>
import Header from '../libs/Header2';
import Foot from '../libs/Foot';
import AllLogin from '../libs/allLogin';
export default {
  name: 'mode',
  data() {
    return { loading:false };
  },
  components: {
    Header,
    Foot,
    AllLogin,
  },
  created() {
    let that = this;

    // that.getGameUrl();
  },
  updated() {},
  mounted() {
    jQuery('.marquee').slide({ mainCell: '.marquee-box ul', autoPage: true, effect: 'topLoop', autoPlay: true, vis: 4, mouseOverStop: false, delayTime: 700 });
    //隐藏左侧主导航
    $('.leftSliderBar .toggle').click(function () {
      $(this).parent('.leftSliderBar').toggleClass('leftSliderMinBar');
      $(this).parent('.leftSliderBar').parent('.leftSliderBarWrap').toggleClass('min');
      $(this).parent('.leftSliderBar').parent('.leftSliderBarWrap').next('.mainContentWrap').toggleClass('leftSliderOpen').toggleClass('leftSliderMin');
    });
  },
  methods: {
        openDaoTime(){
      this.$parent.openDaoTime();
    },
        closeDaoTime(){
      this.$parent.closeDaoTime();
    },
    
        showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
    goNav(url) {
      let that = this;
      if (url == this.$route.fullPath) {
        return;
      }
      this.url = url;
      this.$router.push({ path: url });
    },
    getdogame() {
      let that = this;
      that.$apiFun.post('/api/getdogame', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
          that.dogameLis = res.data;
        }
      });
    },
    getGameUrl() {
      let that = this;
      that.$apiFun.post('/api/getGameUrl', { plat_name: 'AE电子', game_type: 'ae' }).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
        }
      });
    },
    gamelistBycode() {
      let that = this;
      //  pp ae fg obgdy
      that.$apiFun.post('/api/gamelistBycode', { gamecode: 'pp' }).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
        }
      });
    },
    openKefu() {
      let that = this;
      that.showTost('正在链接人工客服');
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
          window.open(res.data.url);
        }
      });
    },
    showTost(type, title) {
      // error  success
      let str = type ? 'success' : 'error';
      $('body').append(`
            <div role="alert" class="ants-message el-message el-message--${str}" style="top: 20px; z-index: 2009;"><i class="el-message__icon el-icon-${str}"></i>
            <p class="el-message__content">${title}
            </p></div>`);
      setTimeout('$(".ants-message").detach()', 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/allMode/mode.vue